module.exports = __webpack_public_path__ + "static/media/boy.669e01f3.svg";